import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Menu, MenuItem } from '@mui/material'
import CreditLimitEditDialog from 'components/customer-details/content/billing/CreditLimitEditDialog'
import T from 'T'
import { get } from 'utils/lodash'
import EditBillingProfileDialog from './edit/EditBillingProfileDialog'
import SuspensionProrationDialog from './SuspensionProrationDialog'
import SuspensionAutomationDialog from './SuspensionAutomationDialog'
import RentalFeeSettingsDialog from './RentalFeeSettingsDialog'
import ChangePaymentTermsDialog from '../payment-terms/ChangePaymentTermsDialog'

const BillingDetailsActionMenu = ({ anchorEl, handleCloseMenu, customerDetails }) => {
  const [isOpenEditBillingDialog, setIsOpenEditBillingDialog] = useState(false)
  const [isOpenCreditLimitDialog, setIsOpenCreditLimitDialog] = useState(false)
  const [isOpenPaymentTermsDialog, setIsOpenPaymentTermsDialog] = useState(false)
  const [isOpenSuspensionProrationDialog, setIsOpenSuspensionProrationDialog] = useState(false)
  const [isOpenSuspensionAutomationDialog, setIsOpenSuspensionAutomationDialog] = useState(false)
  const [isOpenRentalFeeSettingsDialog, setIsOpenRentalFeeSettingsDialog] = useState(false)

  const accountId = get(customerDetails, 'id')

  const handleOpenBillingProfile = () => {
    setIsOpenEditBillingDialog(true)
    handleCloseMenu()
  }

  const handleOpenCreditLimit = () => {
    setIsOpenCreditLimitDialog(true)
    handleCloseMenu()
  }

  const handleOpenPaymentTermsDialog = () => {
    setIsOpenPaymentTermsDialog(true)
    handleCloseMenu()
  }

  const handleOpenSuspensionProrationDialog = () => {
    setIsOpenSuspensionProrationDialog(true)
    handleCloseMenu()
  }

  const handleOpenSuspensionAutomationDialog = () => {
    setIsOpenSuspensionAutomationDialog(true)
    handleCloseMenu()
  }

  const handleOpenRentalFeeSettingsDialog = () => {
    setIsOpenRentalFeeSettingsDialog(true)
    handleCloseMenu()
  }

  const handleCloseBillingProfile = () => {
    setIsOpenEditBillingDialog(false)
  }

  const handleCloseCreditLimit = () => {
    setIsOpenCreditLimitDialog(false)
  }

  const handleClosePaymentTermsDialog = () => {
    setIsOpenPaymentTermsDialog(false)
  }

  const handleCloseSuspensionProrationDialog = () => {
    setIsOpenSuspensionProrationDialog(false)
  }

  const handleCloseSuspensionAutomationDialog = () => {
    setIsOpenSuspensionAutomationDialog(false)
  }

  const handleCloseRentalFeeSettingsDialog = () => {
    setIsOpenRentalFeeSettingsDialog(false)
  }

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleOpenBillingProfile}>{T.BILLING_PROFILE}</MenuItem>
        <MenuItem onClick={handleOpenCreditLimit}>{T.CREDIT_LIMIT}</MenuItem>
        <MenuItem onClick={handleOpenPaymentTermsDialog}>{T.PAYMENT_TERMS}</MenuItem>
        <MenuItem onClick={handleOpenRentalFeeSettingsDialog}>{T.RENTAL_FEE_SETTINGS}</MenuItem>
        <MenuItem onClick={handleOpenSuspensionProrationDialog}>{T.SUSPENSION_PRORATION}</MenuItem>
        <MenuItem onClick={handleOpenSuspensionAutomationDialog}>{T.SUSPENSION_AUTOMATION}</MenuItem>
      </Menu>
      <CreditLimitEditDialog open={isOpenCreditLimitDialog} customerDetails={customerDetails} onClose={handleCloseCreditLimit} />
      <EditBillingProfileDialog isOpen={isOpenEditBillingDialog} customerDetails={customerDetails} onClose={handleCloseBillingProfile} />
      <ChangePaymentTermsDialog isOpen={isOpenPaymentTermsDialog} accountId={accountId} onClose={handleClosePaymentTermsDialog} />
      <SuspensionProrationDialog
        open={isOpenSuspensionProrationDialog}
        onClose={handleCloseSuspensionProrationDialog}
        accountId={accountId}
      />
      <SuspensionAutomationDialog
        open={isOpenSuspensionAutomationDialog}
        onClose={handleCloseSuspensionAutomationDialog}
        accountId={accountId}
      />
      <RentalFeeSettingsDialog open={isOpenRentalFeeSettingsDialog} onClose={handleCloseRentalFeeSettingsDialog} accountId={accountId} />
    </>
  )
}

BillingDetailsActionMenu.propTypes = {
  anchorEl: PropTypes.object,
  handleCloseMenu: PropTypes.func.isRequired,
  customerDetails: PropTypes.object.isRequired,
}

export default BillingDetailsActionMenu
